"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var alt_1 = require("../components/alt");
var LocalesActions = /** @class */ (function () {
    function LocalesActions() {
    }
    LocalesActions.prototype.setCurrentLocale = function (locale) {
        return locale;
    };
    return LocalesActions;
}());
exports.default = alt_1.default.createActions(LocalesActions);
//# sourceMappingURL=locales_actions.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/locales_actions.js
// module id = SswJ
// module chunks = 20 21